AAcom('utilities', 'ajax', function (AAUI) {

    const _busyFormSubmit = AAUI.getProperty('busyProcessing')

        $j(function() {
            // Check state of dropdown on postback
            var dropDownSelected = $j("#milesAmount").val();

            if (dropDownSelected === "custom") {
                $j("#customAmountDiv").show();
            }

            // On Events
            $j("#milesAmount").on("change", function() {
                if (this.value === "custom") {
                    $j("#customAmountDiv").show();
                } else {
                    $j("#customAmountDiv").hide();
                    $j("#customMilesEntered").val("");
                }
            });
        });

       AAUI.initPageSubmit = function() {
           AAUI.onSubmit('#donateMilesViewModel', function() {
               if ($j('body').aaBusy({
                   message: _busyFormSubmit,
                   form: this
               }).start()) {
                   return false;
               }
           });
       };

       // -----------------------------
       // Initializations
       // ------------------------------
       AAUI.initPage = function(pageLoad) {
           pageLoad = pageLoad || false;
           if (pageLoad) {
               AAUI.initPageSubmit();
           }
       };

       $j(document).ready(function() {
           AAUI.initPage(true);
       });

});
